import last from "lodash/last";

export const cleanUpLabel = (string_?: string) => {
  const label = last(string_?.split(":") ?? []) ?? "";
  return label.trim();
};
